import { httpClient } from '@ahm/api-wrappers-core';
import { useInfiniteQuery } from '@tanstack/react-query';
import { apiRoutes } from '@/api/api-routes';
import { PAGE_SIZE } from '@/lib/constants';

export type Transaction = {
  _id: string;
} & Record<string, any>;

export type TransactionsApiResponse = {
  transactions: Transaction[];
  total: number;
};

interface FetchTransactionsParams {
  type: string;
  from_time?: number;
  to_time?: number;
  page?: number;
  count?: number;
}

const fetchTransactions = async ({
  type,
  from_time,
  to_time,
  page = 0,
  count = PAGE_SIZE,
}: FetchTransactionsParams) => {
  const params: any = {
    type,
    page,
    count,
  };

  if (from_time) params.from_time = from_time;
  if (to_time) params.to_time = to_time;

  const res = await httpClient.get<TransactionsApiResponse>(
    apiRoutes.payment.transactions,
    {
      params,
      headers: {
        Authorization: `Bearer ${process.env.AHAMOVE_API_TOKEN}`,
      },
    }
  );

  return res.data;
};

export function useGetTransactions(params: FetchTransactionsParams) {
  return useInfiniteQuery({
    queryKey: [apiRoutes.payment.transactions, params],
    queryFn: ({ pageParam = 0 }) =>
      fetchTransactions({ ...params, page: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.flatMap((page) => page.transactions).length;
      if (totalFetched < lastPage.total) return totalFetched;
      return undefined;
    },
  });
}
